<button [class]="'app-' + app" (click)="zoomPage()" mat-icon-button>
  <mat-icon>zoom_in</mat-icon>
</button>
